module.exports = __webpack_public_path__ + "static/media/VC.a4e5f305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/VC.svg
// module id = 387
// module chunks = 0